<script lang="ts">
    import BootstrapVectorIcon from "./BootstrapVectorIcon.svelte";

    let {
        link,
        onclick
    }: {
        link?: string,
        onclick?: () => void
    } = $props();
</script>

<div class="card h-100 add-card">
    <a href="{link}" class="card-body d-flex align-items-center add-card-link" onclick={onclick}>
        <span class="add-card-icon mx-auto my-auto">
            <BootstrapVectorIcon
                icon={"plus"}
                style="width: 12em; height: 12em;"
            ></BootstrapVectorIcon>
        </span>
    </a>
</div>

<style>
    .add-card-link {
        color: var(--bs-body-color);
        background-color: var(--bs-body-bg);
        transition: background-color 0.2s ease, color 0.2s ease;
    }

    .add-card-link:hover,
    .add-card-link:focus-visible {
        
        background-color: var(--bs-primary-bg-subtle);
    }


    .add-card-icon {
        transition: transform 0.2s ease;
        transform-origin: center;
    }

    .add-card-link:hover .add-card-icon,
    .add-card-link:focus-visible .add-card-icon {
        transform: scale(1.25);
    }
</style>
